import { useQuery } from "react-query";
import { OrganizationAdministration } from "../../api";
import { useAuth } from "../../context";

export const organizationAdministrationKeys = {
  user: () => ["user"],
  division: () => ["division"],
  allSuppliers: () => ["allSuppliers"]
};

export function useGetAllSuppliers(config) {
  const { callApi } = useAuth();
  return useQuery(organizationAdministrationKeys.allSuppliers(),
    () => callApi(OrganizationAdministration.getAllSuppliers), config);
}

export function useGetSupplierUsers(supplierId, config) {
  const { callApi } = useAuth();
  return useQuery([supplierId],
    () => callApi(OrganizationAdministration.getSupplierUsers, supplierId), config);
}

export function useGetOrganizationUsers(config) {
  const { callApi } = useAuth();
  return useQuery(organizationAdministrationKeys.user(),
    () => callApi(OrganizationAdministration.getOrganizationUsers), config);
}